export interface Codec {
  mimeType: string;
  extension: string;
}

// Ordered by playback compatibility
const VIDEO_CODEC_PRIORITY: Codec[] = [
  // prefer H.264 MP4 (plays everywhere, incl. Safari). H.264/AVC is `avc1` and
  // AAC-LC is `mp4a.40.2` per RFC 6381; AVC+AAC in MP4 is the broadest-support
  // combination.
  { mimeType: "video/mp4;codecs=avc1,mp4a.40.2", extension: "mp4" },
  { mimeType: "video/mp4;codecs=avc1", extension: "mp4" },
  { mimeType: "video/mp4", extension: "mp4" },
  // WebM entries name the audio codec (opus) explicitly: Firefox rejects a
  // codecs string that omits the audio codec for an audio-bearing stream,
  // whereas Chromium silently defaults it.
  { mimeType: "video/webm;codecs=vp9,opus", extension: "webm" },
  { mimeType: "video/webm;codecs=vp8,opus", extension: "webm" },
  { mimeType: "video/mp4;codecs=av01", extension: "mp4" },
  { mimeType: "video/webm;codecs=av01,opus", extension: "webm" },
];

const AUDIO_CODEC_PRIORITY: Codec[] = [
  // Safari < 14.1 does not support audio/webm, so mp4 must come before it.
  { mimeType: "audio/mp4", extension: "mp4" },
  { mimeType: "audio/webm;codecs=opus", extension: "webm" },
  { mimeType: "audio/webm", extension: "webm" },
  { mimeType: "audio/ogg;codecs=opus", extension: "ogg" },
];

export function detectCodec(kind: "audio" | "video"): Codec | null {
  const list = kind === "audio" ? AUDIO_CODEC_PRIORITY : VIDEO_CODEC_PRIORITY;
  for (const codec of list) {
    try {
      if (MediaRecorder.isTypeSupported(codec.mimeType)) return codec;
    } catch (e) {
      console.warn(`Codec check failed for ${codec.mimeType}:`, e);
    }
  }
  return null;
}
